(function() {
    "use strict";
    var hdr = document.getElementById("hdr");
    var onScrollHdr = function() {
        hdr.classList.toggle("scrolled", window.scrollY > 24);
    };
    window.addEventListener("scroll", onScrollHdr, {
        passive: true
    });
    onScrollHdr();
    var navAs = {};
    document.querySelectorAll(".nav-links a").forEach(function(a) {
        navAs[a.getAttribute("href").slice(1)] = a;
    });
    var spy = new IntersectionObserver(function(es) {
        es.forEach(function(e) {
            if (e.isIntersecting) {
                Object.keys(navAs).forEach(function(k) {
                    navAs[k].classList.remove("active");
                });
                if (navAs[e.target.id]) navAs[e.target.id].classList.add("active");
            }
        });
    }, {
        rootMargin: "-40% 0px -55% 0px"
    });
    [
        "platform",
        "games",
        "results",
        "deploy",
        "faq"
    ].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) spy.observe(el);
    });
    var mnav = document.getElementById("mnav"), burger = document.getElementById("burger");
    function menu(open) {
        mnav.classList.toggle("open", open);
        mnav.setAttribute("aria-hidden", String(!open));
        burger.setAttribute("aria-expanded", String(open));
        document.body.style.overflow = open ? "hidden" : "";
    }
    burger.addEventListener("click", function() {
        menu(true);
    });
    document.getElementById("mnav-x").addEventListener("click", function() {
        menu(false);
    });
    mnav.querySelectorAll("a").forEach(function(a) {
        a.addEventListener("click", function(ev) {
            var href = a.getAttribute("href");
            menu(false);
            if (href && href.charAt(0) === "#") {
                ev.preventDefault();
                var el = document.querySelector(href);
                if (el) requestAnimationFrame(function() {
                    el.scrollIntoView({
                        behavior: "smooth"
                    });
                });
            }
        });
    });
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") menu(false);
    });
    var lastMenuFocus = null;
    burger.addEventListener("click", function() {
        lastMenuFocus = burger;
        var f = mnav.querySelector("a");
        if (f) f.focus();
    });
    document.getElementById("mnav-x").addEventListener("click", function() {
        if (lastMenuFocus) lastMenuFocus.focus();
    });
})();

//# sourceMappingURL=cookies.915bea8f.js.map
